import moment from 'moment';

import { Component } from 'react';
import { withRouter } from 'react-router-dom';

import ExporterHeader from 'components/importer/ExporterHeader';
import ExporterApi from 'api/exporter';
import DataGrid from 'react-data-grid';
import NoRecords from 'components/ui/DataGrid/NoRecords';

import { withTranslation } from 'react-i18next';
import { MoonLoader } from 'react-spinners';
import { FiDownload } from 'react-icons/fi';

class ExporterPage extends Component {
  state = {
    data: [],
    uploading: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    const data = await ExporterApi.all(this.getType());
    this.setState({ data });
    setTimeout(this.fetchData.bind(this), 3000);
  }

  getType() {
    const { match } = this.props;
    const { type } = match.params;

    return type.toUpperCase();
  }

  dataFormatter = ({ column, row }) => {
    const date_value = row[column.key];

    if (!date_value) {
      return '--';
    }

    return moment(date_value).format('DD/MM/YYYY HH:mm');
  };

  actionFormatter = ({ row }) => {
    const { t } = this.props;

    const output = row.output || {};

    if (!output.location) {
      return null;
    }

    return (
      <div>
        <a title={t('exporter.actions.download_csv')} className="btn btn-icon" href={output.location} rel="noreferrer" target="_blank">
          <FiDownload size={22} />
        </a>
      </div>
    );
  };

  typeFormatter = ({ row }) => {
    const { t } = this.props;
    const type = t(`exporter.types.${row.type.toLowerCase()}`);
    return type.toUpperCase();
  };

  creatorFormatter = ({ row }) => {
    return row.user.name;
  };

  statusFormatter = ({ row }) => {
    const { t } = this.props;

    switch (row.status) {
      case 'FAILED':
        return <div className="text-danger text-uppercase">{t('status.failed')}</div>;

      case 'PROCESSING':
        return (
          <div className="text-primary d-flex align-items-center justify-content-between">
            <MoonLoader size={16} color="#7930e2" />
            <div className="ms-3 text-uppercase">{t('status.processing')}</div>
          </div>
        );

      case 'DONE':
        return <div className="text-success text-uppercase">{t('status.done')}</div>;

      default:
        return <div className="text-muted text-uppercase">{t('status.pending')}</div>;
    }
  };

  render() {
    const { t } = this.props;

    const columns = [
      { key: 'type', name: t('columns.type'), formatter: this.typeFormatter },
      { key: 'status', name: 'Status', formatter: this.statusFormatter },
      { key: 'created_by', name: t('columns.created_by'), formatter: this.creatorFormatter },
      { key: 'created_at', name: t('columns.created_at'), formatter: this.dataFormatter },
      { key: 'started_at', name: t('columns.started_at'), formatter: this.dataFormatter },
      { key: 'done_at', name: t('columns.done_at'), formatter: this.dataFormatter },
      { key: 'actions', name: '', formatter: this.actionFormatter },
    ];

    const rows = this.state.data;

    return (
      <>
        <ExporterHeader />

        <div className="container mt-5">
          <DataGrid columns={columns} rows={rows} className="data-grid rdg-light" rowName="row" rowHeight={60} emptyRowsRenderer={NoRecords} />
        </div>
      </>
    );
  }
}

export default withTranslation()(withRouter(ExporterPage));
